import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'src/componentes/dropdown';
import { useIntl } from 'react-intl';

import Confirm from 'src/componentes/message-box/confirm';
import http from 'src/services/httpService';
import ContentManager from 'src/componentes/content-manager';
import LucideIcon from 'src/componentes/lucide-icon';
import { capitalizeFirstLetter } from 'src/utils/string';
import errorHandler from 'src/utils/error-handler';

function Actions({
  endpoint,
  onRefresh,
  handleOpenEdit,
  showDelete = true,
  showCancelButton = true,
  item,
  viewMenu = false,
  resources,
}) {
  const intl = useIntl();
  const handleEdit = () => handleOpenEdit(item);

  const handleDeleteConfirm = async () => {
    if (!item) return;

    try {
      await http.post(`${endpoint}/Remove`, { id: item.id });
      onRefresh && onRefresh();
    } catch (error) {
      errorHandler(error);
    }
  };

  const handleDelete = async () => {
    ContentManager.addContent(
      <Confirm
        message={capitalizeFirstLetter(
          intl.formatMessage({ id: 'label.desejaMesmoExcluirEsseRegistro' })
        )}
        handleConfirm={handleDeleteConfirm}
      />
    );
  };

  const handleCancel = async () => {
    if (!item) return;

    try {
      await http.post(`${endpoint}/CancelarReuniao`, { reuniaoId: item.id });
      onRefresh && onRefresh();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <UncontrolledDropdown group>
        <DropdownToggle
          color="default"
          size="sm"
          toolbar
          icon="EllipsisVertical"
        />
        <DropdownMenu>
          {
            <DropdownItem onClick={() => handleEdit()}>
              <LucideIcon icon="Pencil" />
              {capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'label.editar' },
                  { editar: resources.editar }
                )
              )}
            </DropdownItem>
          }
          {!viewMenu && showDelete && (
            <DropdownItem onClick={handleDelete}>
              <LucideIcon icon="Trash2" />
              {capitalizeFirstLetter(
                intl.formatMessage({ id: 'label.excluir' })
              )}
            </DropdownItem>
          )}
          {!viewMenu && item?.statusReuniao?.id !== 2 && showCancelButton && (
            <DropdownItem onClick={handleCancel}>
              <LucideIcon icon="Minus" />
              {capitalizeFirstLetter(
                intl.formatMessage({ id: 'label.cancelar' })
              )}
            </DropdownItem>
          )}
        </DropdownMenu>
      </UncontrolledDropdown>
    </>
  );
}

export default Actions;
